import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="password-visibility"
// One button toggles every input marked as a target.
export default class extends Controller {
  static targets = ["input", "button"]

  toggle() {
    const showing = this.inputTargets.some((i) => i.type === "text")
    this.inputTargets.forEach((i) => { i.type = showing ? "password" : "text" })

    if (this.hasButtonTarget) {
      const { showText, hideText } = this.buttonTarget.dataset
      this.buttonTarget.textContent = showing ? (showText || "Show") : (hideText || "Hide")
      this.buttonTarget.setAttribute("aria-pressed", String(!showing))
    }
  }
}
